export default __webpack_public_path__ + "static/media/test2.a46e3a41.png";